module.exports = __webpack_public_path__ + "static/typographyFallback@2x-1ab091dd014bbea53fbcc52638e463d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/typographyFallback@2x.png
// module id = 2593
// module chunks = 168707334958949